import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import './style.scss'

import { Logger, LoggerTypes } from '../../../../utils'
import { Accordion, AccordionDetails, AccordionSummary, Icon, iconNames } from '../../../../components'

export const FlowGroupsAccordion = ({ flowGroups }) => {
  const { t } = useTranslation()

  const [accordionExpanded, setAccordionExpanded] = useState(false)

  const onChangeAccordion = (panel) => (e, newExpanded) => {
    e.preventDefault()
    setAccordionExpanded(newExpanded ? panel : false)
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroupsAccordion.onChangeAccordion()', { accordionExpanded })
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowGroupsAccordion.render()', { flowGroups })

  return (
    <div className="FlowGroupsAccordion">
      {flowGroups &&
        flowGroups.map((el, index) => (
          <Accordion
            key={`flow-action-${index}`}
            expanded={accordionExpanded === el.id}
            onChange={onChangeAccordion(el.id)}
          >
            <AccordionSummary aria-controls={'condition-content'} id={'condition-header'}>
              <Typography>
                <Icon name={iconNames.BPMN} size={14} />
                <span className="iconAccordion">{el?.name || ''}</span>
              </Typography>
            </AccordionSummary>
            {(el?.flows &&
              el.flows.length > 0 &&
              el.flows.map((ell, i) => (
                <AccordionDetails key={`flow-detail-${i}`}>{ell?.name || ''}</AccordionDetails>
              ))) || (
              <AccordionDetails className="no-flow-found">
                {t('flowGroups.left.tabs.flow_groups.no_flows_found')}
              </AccordionDetails>
            )}
          </Accordion>
        ))}
    </div>
  )
}

FlowGroupsAccordion.displayName = 'FlowGroupsAccordion'

FlowGroupsAccordion.propTypes = {
  flowGroups: PropTypes.array.isRequired
}

FlowGroupsAccordion.defaultProps = {
  flowGroups: null
}
